import { DataSourceEnum } from "./connect"

export const dataSourceOptions = [
  // {
  //   label: "Snapshot",
  //   value: DataSourceEnum.SNAPSHOT,
  // },
  // {
  //   label: "Snapshot ECS",
  //   value: DataSourceEnum.SNAPSHOT_ECS,
  // },
  // {
  //   label: "Latest",
  //   value: DataSourceEnum.LATEST,
  // },
  {
    label: "Prod CH (clients here)",
    value: DataSourceEnum.SNAPSHOT_ISOLATED,
  },
  {
    label: "Stage CH",
    value: DataSourceEnum.SNAPSHOT_ISOLATED_DEV,
  },
]
